import { render, staticRenderFns } from "./productFirst.vue?vue&type=template&id=61c63704&scoped=true"
import script from "./productFirst.vue?vue&type=script&lang=js"
export * from "./productFirst.vue?vue&type=script&lang=js"
import style0 from "./productFirst.vue?vue&type=style&index=0&id=61c63704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c63704",
  null
  
)

export default component.exports